<div class="icon">
  <pu-icon [iconName]="aiChatBotIcon" size="40" />
</div>

<div
  class="wrapper"
  [class.chat-started-after]="chatStartedAfter()"
>
  <div class="name">{{ 'aiChatBotName' | translateIn }}</div>

  <chat-message class="bubble">
    <ng-template #textContent>
      @if (message().isSuccessReply) {
        <div class="text">
          @if (showRawReply()) {
            <p class="response" [innerHTML]="text() | parseMarkdown | safeHtml"></p>
          } @else {
            <p class="response">
              {{
                'chatBot.balance.' + message().replyType
                  | translateIn : message().lang || 'en'
                  : { value: balances()[message().replyType] }
              }}

              <br />
              <br />

              <span
                [innerHTML]="'chatBot.balance.task.' + message().replyType | translateIn : message().lang || 'en' | parseMarkdown | safeHtml"
              ></span>
            </p>
          }

          @if (links()?.length > 0) {
            <br />

            @if (
              message().replyType !== chatMessageReplyTypes.JIRA_TASK &&
              message().replyType !== chatMessageReplyTypes.JIRA_READY_TO_CREATE
            ) {
              {{ 'chatBot.links.text' | translateIn : message().lang || 'en' }}
            }

            @for (link of links(); track link.url) {
              <a
                class="link"
                target="_blank"
                puButton
                uiType="quaternary"
                [href]="link.url"
              >
                {{ link.label }}
              </a>
            }
          }
        </div>
      } @else if (message().internalStatus === internalMessageStatus.pending) {
        <div class="loading-dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      } @else if (message().internalStatus === internalMessageStatus.timeout) {
        <div class="error">
          {{ 'chatBot.timeout.internal' | translateIn: 'en' }}
        </div>
      } @else if (message().status === chatMessageStatus.Error || message().internalStatus === internalMessageStatus.failed) {
        <div class="error">
          {{ 'chatBot.error.text' | translateIn: 'en' }}
        </div>
      } @else if (message().status === chatMessageStatus.InProgress) {
        <div class="error">
          {{ 'chatBot.timeout.text.before' | translateIn : 'en' }}
          <button
            type="button"
            puButton
            uiType="quaternary"
            (click)="tryAgain()"
          >
            {{ 'chatBot.timeout.tryAgain' | translateIn : 'en' }}
          </button>

          {{ 'chatBot.timeout.text.after' | translateIn : 'en' }}

          <a
            class="link"
            puButton
            uiType="quaternary"
            [puSlackLink]="message().ppSlackId"
            target="_blank"
          >
            {{ message().ppFullName }}
          </a>
        </div>
      } @else if (!message().isSuccessReply) {
        <div class="error">
          <p class="response" [innerHTML]="text() | parseMarkdown | safeHtml"></p>

          <br />

          {{ 'chatBot.notFound.text.rephrase.' + randomRephrase(message().createdAt) | translateIn : message().lang || 'en' }}

          <br />
          <br />

          {{ 'chatBot.notFound.text.contactPP' | translateIn : message().lang || 'en' }}

          <a
            class="link"
            puButton
            uiType="quaternary"
            [puSlackLink]="message().ppSlackId"
            target="_blank"
          >
            {{ message().ppFullName }}
          </a>

          {{ 'chatBot.notFound.text.contactList' | translateIn : message().lang || 'en' }}

          <a
            class="link"
            puButton
            uiType="quaternary"
            target="_blank"
            [href]="message().ppConfluencePage"
          >
            {{ 'chatBot.notFound.text.list' | translateIn : message().lang || 'en' }}
          </a>

          <br />
          <br />

          {{ 'chatBot.finance.related' | translateIn: message().lang || 'en' }}

          <a
            class="link"
            puButton
            uiType="quaternary"
            [href]="originLink + '/my-requests/financial'"
          >
            {{ 'chatBot.finance.related.link' | translateIn : message().lang || 'en' }}
          </a>
        </div>
      }

      <span class="time">{{ message().createdAt | messageDate }}</span>
    </ng-template>
  </chat-message>

  @if (displayReaction()) {
    <message-reaction
      [messageId]="message().id"
      [reaction]="message().reactionType"
      [feedbackProvided]="!!message().isFeedbackProvided"
    />
  }
</div>
